import { Http } from '@/lib/http';

export class GeneralLedgerAccountsService extends Http {
    constructor() {
      super();
      
      this.endpoint = 'gl/settings/general-ledger-accounts';
    }

    create(payload) {
      return this.httpClient().post(`${this.endpoint}`, payload);
    }
  
    findAll() {
      return this.httpClient().get(`${this.endpoint}`);
    }
  
    update(id, payload) {
      return this.httpClient().put(`${this.endpoint}/${id}`, payload);
    }
  
    delete(id) {
      return this.httpClient().delete(`${this.endpoint}/${id}`);
    }

    
    getGeneralLedgerNumbers(type) {
      return this.httpClient().get(`${this.endpoint}/ledgers/gl?type=${type}`)
    }
    getPersonalLedgerNumbers() {
      return this.httpClient().get(`${this.endpoint}/ledgers/personal`)
    }
  }